import { colors, makeStyles } from "@material-ui/core";
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(theme => ({
  icon: {
    "-webkit-touch-callout": "none",
    "-webkit-user-select": "none",
    "-khtml-yser-select": "none",
    "-moz-user-select": "none",
    "-ms-user-select": "none",
    "user-select": "none",
    marginLeft: 3,
    fontWeight: 600
  },
  blue: {
    color: colors.blue[300]
  },
  pink: {
    color: colors.pink[300]
  }
}));

const GenderIcon = props => {
  const classes = useStyles();

  let { gender } = props;
  if (!gender) return "";
  let text = "";
  let color = null;
  switch (gender.toLowerCase()) {
    case "male":
      text = "♂";
      color = classes.blue;
      break;
    case "female":
      text = "♀";
      color = classes.pink;
      break;
    default:
      text = "";
  }
  return <span className={clsx(classes.icon, color)}>{text}</span>
}

export default GenderIcon;